import config from "appConfig";
import { LayoutComponents } from "packages/lesson/dist/@types";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 3,
        rows: 3,
        colSpan: {
          "1:0": 3,
          "2:0": 3,
        },
        colsSize: [1, 0.8, 1],
        rowsSize: [1, 2, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-weight:700">Room 1 (source room)</span></br></br>V<sub>1</sub> = 75 m<sup>3</sup></br>A<sub>1</sub> = 24 m<sup>2</sup></br>T<sub>1</sub> = 0.5 s`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      textAlign: "center",
                      fontWeight: 400,
                      lineHeight: "16px",
                      fontSize: "12px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-weight:700">Sound reduction index</br>of separating wall</span></br>R = 40 dB`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      textAlign: "center",
                      fontWeight: 400,
                      lineHeight: "16px",
                      fontSize: "12px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-end",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-weight:700">Room 2 (receiving room)</span></br></br>V<sub>2</sub> = 75 m<sup>3</sup></br>A<sub>2</sub> = 6 m<sup>2</sup></br>T<sub>2</sub> = 2 s`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      textAlign: "center",
                      fontWeight: 400,
                      lineHeight: "16px",
                      fontSize: "12px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-end",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/25/principle/case-2.svg`,
                  },
                },
                styles: {
                  padding: "0 3%",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `sound insulaton obtained between room 1 and room 2:</br>sound level difference</br><span style="font-weight:400">D - L1 - L2 = 36 dB`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      textAlign: "center",
                      fontWeight: 700,
                      lineHeight: "16px",
                      fontSize: "12px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
